import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-MoreShape",
  "use": "svg-icon-MoreShape-usage",
  "viewBox": "0 0 16 4",
  "content": "<symbol viewBox=\"0 0 16 4\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-MoreShape\"><path d=\"M14 .125a1.874 1.874 0 1 1 .001 3.749A1.874 1.874 0 0 1 14 .125zm-5.906 0a1.874 1.874 0 1 1 0 3.749 1.874 1.874 0 0 1 0-3.749zM2 .125a1.874 1.874 0 1 1 .001 3.749A1.874 1.874 0 0 1 2 .125z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol